import React from 'react';
import { Box, Text } from '@quintoandar-tokko/jopijs';
import styles from './pendingLeadsCard.module.scss';
import ProfilePicture from '../../ProfilePicture';
import TimeStatusIndicator from '../../TimeStatusIndicator';
import translations from '../../../Dashboard.trans.json';
import Trans from '@/components/shared/Trans';
import EventParticipantTag from '../../PendingEvents/PendingEventCard/EventParticipant/EventParticipantTag';
import { getContactCardData } from '../../utils';
import { useContrastTextColor } from '@/components/shared/Hooks';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';

function SingleUserCard({ lead = [], trackCallback = null }) {
  const daysToExpire = Math.floor(lead.hours_until_expiry / 24);
  const displayTime = !daysToExpire
    ? Trans(translations, 'Today')
    : `${daysToExpire} ${daysToExpire === 1 ? 'day' : 'days'}`;

  if (!lead.agent) return null;

  const participantData = getContactCardData({
    ...lead,
    agent: { agent: lead.agent.name, agent_id: lead.agent.id },
  });
  const toolTipText = Trans(translations, 'ExpireIn');
  const { textColor } = useContrastTextColor(
    `#${lead?.lead_status?.color || '000000'}`
  );

  const handleClickCard = () => {
    if (trackCallback) {
      trackCallback(TRACK_ELEMENT.ROW);
    }
  };

  return (
    <Box className={styles.pendingLeadsCard} onClick={handleClickCard}>
      <Box className={styles.leftContentContainer}>
        <ProfilePicture
          src={lead.profile_picture_url}
          alt="contact picture"
          width={40}
        />
        <EventParticipantTag
          alignItems="flex-start"
          participants={[participantData]}
          contactDataParsed
          trackCallback={trackCallback}
        />
      </Box>
      <Box className={styles.rightContentContainer}>
        <Text
          backgroundColor={`#${lead.lead_status?.color}`}
          variant="bodyBold.fontSize14"
          className={styles.leadStatusBadge}
          color={textColor}
        >
          {lead.lead_status?.name}
        </Text>
        <TimeStatusIndicator
          mode="remaining"
          threshold={24}
          value={lead.hours_until_expiry}
          displayTime={displayTime}
          toolTipText={toolTipText}
        />
      </Box>
    </Box>
  );
}

export default SingleUserCard;
